import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=12fb9cec&scoped=true&lang=pug"
import script from "./OurTeam.vue?vue&type=script&lang=js"
export * from "./OurTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb9cec",
  null
  
)

export default component.exports